export const CASE_NOUN = {
  nominative: 'nominative',
  genitive: 'genitive',
  dative: 'dative',
  accusative: 'accusative',
  creative: 'creative',
  prepositional: 'prepositional',
}
